import React, { useState } from "react";
import { Switch, Input, Drawer, Form, Button, Image, Select } from "antd";
import { videosMercados } from "../../../constants/constants";
import TextArea from "antd/es/input/TextArea";
import { requestWithImage } from "../../../functions/request";
import { toast } from "react-toastify";
import { uniKey, validData } from "../../../functions/functionsUtility";
import { Content } from "antd/es/layout/layout";

function ModalAddDossie(props) {
  const [bannerImage, setBannerImage] = useState(null);
  const [capaImage, setCapaImage] = useState(null);

  const saveData = async () => {
    const result = await validData(props.editOpen, [
      "dos_nome",
    ]);
    if (!result) {
      toast.error("Preencha todos os campos obrigatórios! Campo: Nome");
      return false;
    }
    const formData = new FormData();
    let dataAux = {
      dos_ativo: 0,
    };
    for (const key in props?.editOpen) {
      if (props?.editOpen[key] !== null && props?.editOpen[key] !== undefined) {
        dataAux[key] = props?.editOpen[key];
      }
    }
    dataAux.index = uniKey();
    const newData = JSON.stringify(dataAux);
    formData.append("newData", newData);
    formData.append("dos_banner", bannerImage);
    formData.append("dos_capa", capaImage);
    const response = await requestWithImage("/dossie/insertDossie", {
      method: "POST",
      body: formData,
    })
      .then((res) => {
        toast.success("Dossiê Salvo com Sucesso!");
        props?.onRequestClose();
        props?.setEditOpen({});
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Erro ao Salvar Dossiê!");
      });
  };

  console.log(props);
  return (
    <>
      <Drawer
        title={
          props?.editOpen?.dos_id ? "Editar Dossiê" : "Adicionar Novo Dossiê"
        }
        open={props?.isAddOpen}
        onClose={props?.onRequestClose}
        extra={
          <Button
            type="primary"
            onClick={(el) => {
              if (props?.editOpen?.dos_id) {
                props.changeDossies(props.editOpen, bannerImage, capaImage);
              } else {
                saveData();
              }
            }}
          >
            Salvar
          </Button>
        }
      >
        <Form layout="vertical">
          <Form.Item label={"Título"}>
            <Input
              value={props?.editOpen?.dos_nome}
              onChange={(e) =>
                props?.setEditOpen({
                  ...props?.editOpen,
                  dos_nome: e.target.value,
                })
              }
            />
          </Form.Item>
          <Form.Item label={"Descrição"}>
            <TextArea
              value={props?.editOpen?.dos_desc}
              onChange={(e) =>
                props?.setEditOpen({
                  ...props?.editOpen,
                  dos_desc: e.target.value,
                })
              }
            />
          </Form.Item>
          {/* Mercado e o unico campo que o dossie tem a mais que a serie:
              permite filtrar dossie por mercado no app, como ja acontece
              com os videos. Usa os mesmos codigos de vid_mercado. */}
          <Form.Item label={"Mercado"}>
            <Select
              style={{ width: "100%" }}
              allowClear
              placeholder="Selecione o mercado"
              value={props?.editOpen?.dos_mercado ?? undefined}
              options={videosMercados}
              onChange={(v) =>
                props?.setEditOpen({ ...props?.editOpen, dos_mercado: v ?? null })
              }
            />
          </Form.Item>
          <Form.Item label={"Capa"}>
            <Content style={{ display: "flex", gap: 5 }}>
              {props?.editOpen?.dos_capa && (
                <Image
                  src={`${process.env.REACT_APP_API_RB}/dossie/imagens/${props?.editOpen?.dos_capa}`}
                  style={{ aspectRatio: "2 / 3", borderRadius: 8 }}
                  width={100}
                />
              )}
              <Input
                onChange={(e) => {
                  setCapaImage(e.target.files[0]);
                }}
                type="file"
                accept="image/*"
              />
            </Content>
          </Form.Item>
          <Form.Item label={"Banner"}>
            <Content style={{ display: "flex", gap: 5 }}>
              {props?.editOpen?.dos_banner && (
                <Image
                  src={`${process.env.REACT_APP_API_RB}/dossie/imagens/${props?.editOpen?.dos_banner}`}
                  style={{ aspectRatio: "2 / 3", borderRadius: 8 }}
                  width={100}
                />
              )}
              <Input
                onChange={(e) => setBannerImage(e.target.files[0])}
                type="file"
                accept="image/*"
              />
            </Content>
          </Form.Item>
          <Form.Item label={"Ativo"}>
            <Switch
              onChange={(e) =>
                props?.setEditOpen({ ...props?.editOpen, dos_ativo: e })
              }
              checked={props?.editOpen?.dos_ativo}
            />
          </Form.Item>
        </Form>
      </Drawer>
    </>
  );
}

export default ModalAddDossie;
